<div class="w-full max-w-full sm:w-full mx-auto sm:mx-0">
    <!-- Logo -->
    <div class="w-50" *ngIf="signupConf.logo">
        <img [src]="signupConf.logo" aria-label="logo" alt="">
    </div>

    <!-- Title -->
    <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">{{signupConf.title}}</div>
    <div class="flex items-baseline mt-0.5 font-medium">
        <div>Already have an account?</div>
        <a class="ml-1 text-primary-500 hover:underline"
            [routerLink]="[signupConf.redirectRouterLink]">Sign in
        </a>
    </div>

    <!-- Alert -->
    <fuse-alert
        class="mt-8"
        *ngIf="signupConf.showTopAlert && showAlert"
        [appearance]="'outline'"
        [showIcon]="false"
        [type]="alert.type"
        [@shake]="alert.type === 'error'">
        {{alert.message}}
    </fuse-alert>

    <!-- Sign Up form -->
    <app-dynamic-form [listOfFormElements]="elementList" (saveCallBack)="signup($event)"
                      (cancelCallBack)="login($event)" [spanLayout]="signupConf.spanLayout"
                      [fnBtnName]="signupConf.fnBtnName"
                      [closeBtnName]="signupConf.closeBtnName"></app-dynamic-form>
    <fuse-alert class="mt-8"
        *ngIf="signupConf.showBottomAlert && showAlert"
        [appearance]="'outline'"
        [showIcon]="false"
        [type]="alert.type"
        [@shake]="alert.type === 'error'">
        {{alert.message}}
    </fuse-alert>
</div>
